import { SR_API_ACTION_BUYER_SIDE_AGENT_UPDATE } from 'api/actionTypes';

export default async function updateBuyerSideAgent({ state, apiClient }, { agentMlsNumber }) {
  await apiClient.postWithState({
    action: SR_API_ACTION_BUYER_SIDE_AGENT_UPDATE,
    state: state,
    payload: {
      agentMlsNumber,
    },
    onSuccess(userUpdated) {
      state.set(['currentUser'], {
        ...state.get(['currentUser']),
        ...userUpdated,
      });
    },
  });
}
